export default __webpack_public_path__ + "static/media/team.24aec655.jpg";